import Lenis from 'lenis'
import 'lenis/dist/lenis.css'

let lenis: Lenis

window.addEventListener('load', () => {
  lenis = new Lenis({
    autoRaf: true,
    duration: 1.2,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
  })

  window.scrollTo(0, 0)

  const hash = window.location.hash

  if (hash) {
    setTimeout(() => {
      const anchor = document.querySelector(hash) as HTMLElement

      if (anchor && window.fScrollToElement) {
        window.fScrollToElement(anchor)
      }
    }, 700)
  }

  const links = document.querySelectorAll('a[href^="/#"], a[href^="#"]')

  links.forEach((link) => {
    link.addEventListener('click', (event) => {
      const header = document.querySelector('[data-item="web-header"].isOpen')

      if (header) {
        header.classList.remove('isOpen')
      }

      if ((link.getAttribute('href') as string).split('#')[1]) {
        let anchor: HTMLElement | null = null

        anchor = document.querySelector(
          `#${(link.getAttribute('href') as string).split('#')[1]}`,
        )

        if (anchor) {
          event.preventDefault()

          setTimeout(() => {
            if (window.fScrollToElement) window.fScrollToElement(anchor)
          }, 700)
        }
      }
    })
  })
})

// Scroll to element on custom  event
window.addEventListener('bw-scroll-to-element', (e: Event) => {
  // Get element to scroll to
  const target = (e as CustomEvent).detail.target

  if (target && window.fScrollToElement) {
    window.fScrollToElement(target)
  }
})

/**
 *
 * @param {htmlElement} element - element to which page should scroll
 * Pin function to window, so it may be used anywhere
 */
window.fScrollToElement = (element, constOffset = 0) => {
  return new Promise((resolve, reject) => {
    if (element) {
      // Add listener to return callback when scroll stops
      const listener = () => {
        document.removeEventListener('scrollStop', listener, false)

        resolve('scroll finished')
      }

      document.addEventListener('scrollStop', listener, false)

      let offset = window.innerHeight * 0.2

      if (constOffset) {
        offset = constOffset
      }

      if (window.innerWidth <= 1200) {
        offset = window.innerHeight * 0.1

        if (constOffset) {
          offset = 130
        }
      }

      // Animate to element with given options
      lenis.scrollTo(element, {
        duration: 2,
        offset: offset,
      })
    }
  })
}

window.fScrollToTop = (number) => {
  return new Promise((resolve, reject) => {
    if (number) {
      lenis.scrollTo(number, {
        duration: 2,
      })
    }
  })
}
